import * as yup from 'yup';

export const auditFormSchema = yup.object().shape({
  pinned_to_type: yup
    .string()
    .oneOf(['Practice', 'Methodology'])
    .required('common.fieldRequired'),
  pinned_to_id: yup.number().required('common.fieldRequired'),
  name: yup.string().required('common.fieldRequired'),
  id_code: yup.string().required('common.fieldRequired'),
  color_code: yup.string().required('common.fieldRequired'),
  goal: yup.string().required('common.fieldRequired'),
  rating_scale_id: yup.number().required('common.fieldRequired')
});
